module.exports = __webpack_public_path__ + "static/media/sensorPic3.1074871b.jpg";